import React, { useMemo, useState } from 'react'
import { motion } from 'motion/react'

import { EffectBackgroundProps, ParticleData } from '../types'

export const StarsEffect = React.memo(({ layerStyle, index, values }: EffectBackgroundProps) => {
  const effectColors = useMemo(() => values.effectColors || ['#ffffff'], [values.effectColors])
  const effectSpeed = values.effectSpeed ?? 100
  const effectOpacity = values.effectOpacity ?? 100
  const effectBackgroundColor = values.effectBackgroundColor || '#000000'
  const opacityValue = effectOpacity / 100
  const starColor = effectColors[0] || '#ffffff'

  const [stars] = useState(() => {
    const newStars: Array<ParticleData> = []
    for (let i = 0; i < 200; i++) {
      newStars.push({
        id: i,
        x: Math.random() * 100,
        y: Math.random() * 100,
        size: 1 + Math.random() * 2,
        speed: 2 + Math.random() * 3,
      })
    }
    return newStars
  })

  return (
    <div
      style={{
        position: 'absolute' as const,
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: -index - 1,
        backgroundColor: effectBackgroundColor,
      }}
    >
      {stars.map((star) => (
        <motion.div
          key={star.id}
          style={{
            position: 'absolute',
            left: `${star.x}%`,
            top: `${star.y}%`,
            width: star.size,
            height: star.size,
            backgroundColor: starColor,
            boxShadow: `0 0 ${star.size! * 1.5}px ${starColor}`,
            borderRadius: '50%',
          }}
          animate={{
            opacity: [0.3 * opacityValue, 0.9 * opacityValue, 0.3 * opacityValue],
            scale: [1, 1.1, 1],
          }}
          transition={{
            duration: star.speed! * (100 / Math.max(effectSpeed, 1)),
            repeat: Infinity,
            ease: 'easeInOut',
            delay: Math.random() * 3,
          }}
        />
      ))}
    </div>
  )
})
StarsEffect.displayName = 'StarsEffect'
